import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import { getDataApiDebug } from "../../../../hooks/api/apiDebug";
import DataApiDebug from "./DataApiDebug";
import './apiDebug.css';

export default function ViewApiDebug() {
  const globalContext = useContext(GlobalContext);
  const [inputSku, setInputSku] = useState("");
  const [inputProductId, setInputProductId] = useState(null);
  const [dataResApiDebug, setDataResApiDebug] = useState(null);
  const [loading, setLoading] = useState(false);

 
  useEffect(() => {
  }, [globalContext.currentEnterpriseId]);
  const executeApi =  async () => {
    setDataResApiDebug([]);
    setLoading(true);
    const params = {
      page: 1,
      limit: 10,
      enterpriseId: await globalContext.currentEnterpriseId,
    }

    if(inputProductId) params.productId = Number(inputProductId)
    if(inputSku) params.sku = inputSku;
    const data = await getDataApiDebug(params);
    setDataResApiDebug(data.data.data.apiDebug || []);
    setLoading(false);
  }
 
  return (
    <>
      <h1 className="text-center mt-5">Consultas para la <strong>Api Debug</strong></h1>
      <p className="text-center mt-5">Ingresa un sku o productId de odoo para consultar</p>
      <div className="d-flex align-items-center justify-content-center">
          <div>
              <div className="container d-flex justify-content-center mt-2">
                <h5 style={{width:130, textAlign:'end', paddingRight:20}}>Sku</h5>
                <input
                  style={{width: 300, padding: '8px 0', textAlign:'center'}}
                  type="text"
                  value={inputSku}
                  onChange={(e) => setInputSku(e.target.value)}/>
              </div>
              <div className="container d-flex justify-content-center mt-2">
                <h5 style={{width:130, textAlign:'end', paddingRight:20}}>Product ID</h5>
                <input
                  style={{width: 300, padding: '8px 0', textAlign:'center'}}
                  type="text"
                  value={inputProductId}
                  onChange={(e) => setInputProductId(e.target.value)}/>
              </div>
          </div>
          <button onClick={()=>executeApi()} style={{padding: '0 27px', backgroundColor: '#014788', color: '#FFF', height:50, borderRadius: '0 15px 0 '}}>Buscar</button>
      </div>
      <div className="container d-flex flex-column justify-content-center align-items-center mt-5" style={{gap: 60}}>
        {
          dataResApiDebug && dataResApiDebug?.length > 0 ? 
            (
              dataResApiDebug.map((item, index) => {
                return <DataApiDebug key={index} data={item}/>
            }
          )) : 
            loading && (
              <div className='col-12 d-flex justify-content-center align-items-center' style={{height: 'calc(100vh - 400px)'}}>
                <div className="loader"></div>
              </div>
            ) || <></>
          
        }
      </div>
    </>
  );
}
